import date from 'date-and-time';
import { Music24PlanTier, music24PlanCapabilities } from 'fym-shared/src/music24/music24Plans';

/** The Home period on every paid plan and on the trial. */
export const HOME_PERIOD_DAYS = 28;

/** The Home period on a plan whose history is shorter than 28 days (Free). */
export const HOME_SHORT_PERIOD_DAYS = 7;

export type HomePeriodDays = typeof HOME_PERIOD_DAYS | typeof HOME_SHORT_PERIOD_DAYS;

/**
 * The days every Home number covers (owner decision 1): 28, or 7 when the workspace history limit
 * is below 28. Both values are windows the stats, insights and portal endpoints accept.
 */
export function homePeriodDays(historyDaysLimit: number): HomePeriodDays {
  return historyDaysLimit < HOME_PERIOD_DAYS ? HOME_SHORT_PERIOD_DAYS : HOME_PERIOD_DAYS;
}

export interface HomePeriodRange {
  from: Date;
  to: Date;
}

/**
 * The first and the last day of the period. The smartlink stats window ends today and counts today
 * as one of its days (music24-api `statsWindowStart`), so the label uses the same days.
 */
export function homePeriodRange(days: number, now: Date): HomePeriodRange {
  const to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return { from: date.addDays(to, -(days - 1)), to };
}

// Plug costs the most ($299), so it is last: a cheaper plan with the same history always wins.
const PAID_TIERS_CHEAPEST_FIRST: readonly Music24PlanTier[] = ['artist', 'pro', 'manager', 'label', 'plug'];

/** The cheapest plan whose history covers the full Home period: the lock chip names it (design b2). */
export function homeFullPeriodPlan(): Music24PlanTier {
  return (
    PAID_TIERS_CHEAPEST_FIRST.find((tier) => music24PlanCapabilities[tier].historyDaysLimit >= HOME_PERIOD_DAYS) ??
    'artist'
  );
}
